export default "https://cdn-static.gokick.com/assets/bf292cd7043bd3c72a48f3c1f30d1b93bc9276ca/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";